module.exports = __webpack_public_path__ + "static/media/lepes12.9aa5d559.png";